import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class WordpressService {
  private http = inject(HttpClient);

  private apiUrl =
    'https://www.meteofocus.com/wp-json/wp/v2/posts?categories=189,196,198,200';
  private lastCallTime: number = 0;
  private dataSubject = new BehaviorSubject<any>(null); // Für die Zwischenspeicherung
  private categories = {
    de: 189,
    us: 196,
    fr: 198,
    es: 200,
    nl: 196,
  };

  getData(): Observable<any> {
    const now = Date.now();

    if (now - this.lastCallTime < 60000) {
      // Letzter Aufruf war vor weniger als einer Minute
      return of(null); // Oder einen zwischengespeicherten Wert
    } else {
      // API-Aufruf notwendig
      return this.http.get<any[]>(this.apiUrl).pipe(
        tap(data => {
          this.lastCallTime = now;
          //this.dataSubject.next(this.teaserTitle(data)); // Daten im BehaviorSubject speichern
          return data;
        })
      );
    }
  }

  public languageCategory(language: string): number {
    if (this.categories.hasOwnProperty(language)) {
      return this.categories[language];
    }
    return 0;
  }
}
